export const ITEMS_PER_PAGE = 10;

export const INITIAL_INVENTORY_ARTICLE_STATE = {
  uuid: null,
  code: '',
  name: '',
  description: '',
  uuid_unit: '',
  external_code: '',
  is_active: true,
};

export const VALIDATION_RULES = {
  REQUIRED_FIELDS: ['code', 'name'],
  CODE_MAX_LENGTH: 50,
  NAME_MAX_LENGTH: 150,
  EXTERNAL_CODE_MAX_LENGTH: 80,
};

export const MESSAGES = {
  ERROR: {
    REQUIRED_FIELD: 'Este campo es obligatorio',
    INVALID_CODE: 'El código no puede estar vacío',
    INVALID_NAME: 'El nombre no puede estar vacío',
  },
};
